export default __webpack_public_path__ + "static/media/kapoor-lake-mandu.a5b6cdea.jpg";